import { Link, useNavigate } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";
import Navbar from "../../components/Navbar/Navbar";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading";
import ShimmerLoader from "../../loading";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PosDashboard from "./Posdashbord";
import OnlinePosDashboard from "./OnlinePosDashboard";
import OnlineDashboard from "./OnlineDashboard";
import DateFilter from "../../components/ui/DateFilter";
import dayjs from "dayjs";
import { ReloadOutlined } from "@ant-design/icons";
import { motion } from "framer-motion"; // install: npm i framer-motion
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import i18n from "../../i18n";
import axiosInstance from "../../AxiosInstance";
import { Select } from "antd";
import { URLS } from "../../API/API endpoints";

const Dashboard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Option } = Select;

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedSession, setSelectedSession] = useState(null);
  const [allSessions, setAllSessions] = useState([]);

  const [selected, setSelected] = useState("E-Orders + POS");

  const tabs = ["E-Orders + POS", "POS", "E-Orders"];
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";
  const showCashier =
    contractType === "Cashier" || contractType === "Cashier_Ecom";
  const showEcom = contractType === "ECom" || contractType === "Cashier_Ecom";
  const showToggle = contractType === "Cashier_Ecom";

  const is_retailer = useSelector(
    (state) => state?.login?.user?.result?.is_retailer
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetSessions();
    setSelectedSession(null);
  }, [company_id]);

  const GetSessions = async () => {
    try {
      const response = await axiosInstance.post(URLS.GET_POS_SESSION_LIST, {
        company_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      });

      if (response?.data?.result?.status_code === 200) {
        setAllSessions(response?.data?.result?.data);
      } else {
        setAllSessions([]);
      }
    } catch (error) {
      console.log("Session fetch error:", error);
      setAllSessions([]);
    }
  };

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      setSelectedRange("thisMonth");
      setSelectedSession(null);
      setStartDate(startofMonth);
      setEndDate(formatToday);
      setSelected(newValue);
    }
  };

  const onSessionChange = (value) => {
    setSelectedSession(value);
  };

  return (
    <>
      {/* {loading && <LoadingSpinner />} */}
      <div className="w-full flex flex-col md:h-full overflow-y-auto bg-[#F6F7F9] hide-scrollbar">
        <div>
          <Navbar heading="Dashboard" />
        </div>
        <div className="flex-grow overflow-y-auto  overflow-hidden mx-4 hide-scrollbar">
          <div className="flex justify-between w-full px-4 mt-4 items-center">
            <div className=" w-16"></div>
            {showToggle && (
              <ToggleButtonGroup
                value={selected}
                exclusive
                onChange={handleChange}
                sx={{
                  borderRadius: "9999px",
                  border: "1px solid #d1d5db",
                  backgroundColor: "#fff",
                  p: "4px",
                  "& .MuiToggleButton-root": {
                    border: "none",
                    borderRadius: "9999px",
                    textTransform: "none",
                    padding: "6px 24px",
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    transition: "all 0.3s ease",
                    fontFamily: i18n.language == "ar" ? "Cairo" : "sans-serif",
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#38bdf8 !important",
                    color: "#fff !important",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <ToggleButton value="E-Orders + POS">
                  {t("E-Orders + Cashier")}
                </ToggleButton>
                <ToggleButton value="POS">{t("Cashier")}</ToggleButton>
                <ToggleButton value="E-Orders">{t("E-Orders")}</ToggleButton>
              </ToggleButtonGroup>
            )}
            <button
              className=" w-44 h-10 bg-primaryBlue text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2"
              onClick={() => navigate("/onboarding")}
            >
              <span>{t("Go to Onboarding")}</span>
            </button>
          </div>
          <div className={`flex mt-3 justify-between mx-6 items-center`}>
            {!showToggle && contractType === "Cashier" ? (
              <span className=" font-semibold text-lg mt-2">
                {t("Cashier Dashboard")}
              </span>
            ) : !showToggle && contractType === "ECom" ? (
              <span className=" font-semibold text-lg mt-2">
                {t("E-Orders Dashboard")}
              </span>
            ) : (
              <div></div>
            )}
            {/* {selected === "E-Orders + POS" && ( */}
            <div className="flex">
              {((showToggle && selected === "POS") ||
                (!showToggle && contractType === "Cashier")) && (
                <>
                  {selectedSession != null && (
                    <span
                      onClick={() => {
                        setSelectedSession(null);
                      }}
                      className="flex flex-row justify-end font-medium text-sm text-primaryBlue cursor-pointer mt-5 me-3"
                    >
                      {t("Clear Filter")}
                    </span>
                  )}

                  <Select
                    showSearch
                    optionFilterProp="children"
                    className="overflow-hidden mt-2 me-3"
                    style={{ width: 340, height: 40 }}
                    placeholder={t("All Sessions")}
                    value={selectedSession ?? null}
                    onChange={onSessionChange}
                  >
                    <Option value={null}>{t("All Sessions")}</Option>

                    {allSessions.map((s) => (
                      <Option key={s?.id} value={s?.id}>
                        {s?.name}
                      </Option>
                    ))}
                  </Select>
                </>
              )}
              <DateFilter
                setSelectedRange={setSelectedRange}
                selectedRange={selectedRange}
                SubmitFilter={(start, end) => {
                  setSelectedSession(null);
                  setStartDate(start);
                  setEndDate(end);
                }}
                disabled={selectedSession}
              />
              {/* )} */}
              <div
                className="flex items-center text-gray-500 cursor-pointer ms-4 text-sm mt-2 "
                onClick={() => setRefreshKey((prev) => prev + 1)}
              >
                <ReloadOutlined />
                <p className=" ms-2">{t("Refresh")}</p>
              </div>
            </div>
          </div>

          <div className="w-full">
            {/* For Cashier_Ecom → allow switching */}
            {showToggle && selected === "E-Orders + POS" && (
              <OnlinePosDashboard
                start={startDate}
                end={endDate}
                refreshKey={refreshKey}
              />
            )}
            {showToggle && selected === "POS" && (
              <PosDashboard
                start={startDate}
                end={endDate}
                refreshKey={refreshKey}
                selectedSession={selectedSession}
              />
            )}
            {showToggle && selected === "E-Orders" && (
              <OnlineDashboard
                start={startDate}
                end={endDate}
                refreshKey={refreshKey}
              />
            )}

            {/* For Cashier only */}
            {!showToggle && contractType === "Cashier" && (
              <PosDashboard
                start={startDate}
                end={endDate}
                refreshKey={refreshKey}
                selectedSession={selectedSession}
              />
            )}

            {/* For ECom only */}
            {!showToggle && contractType === "ECom" && (
              <OnlineDashboard
                start={startDate}
                end={endDate}
                refreshKey={refreshKey}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
